import router from '@/router'
export const ToDocumentTitle = () => {
  const current = router.history.current
  let title = ''
  const list = JSON.parse(localStorage.getItem('navList') || '[]')
  list.forEach((item) => {
    const url = item.url && item.url.indexOf('.wechain360.com') !== -1 ? item.url.split('.wechain360.com')[1] : item.url
    if (url === current.path) {
      title = item.name
    }
  })
  if (title) {
    const titleList = document.title.split(' | ')
    if (titleList.length > 1) {
      document.title = title + ' | ' + titleList[1]
    } else {
      document.title = title + ' | ' + document.title
    }
  }
}